import Vue from "vue";
let currentRequest = 0;

const TenantService = {
  async fetchOne(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.find("tenants", id, {});
      return data.data[0];
    } catch (error) {
      console.log("fetchOne error: ", error);
      return { error: error };
    }
  },
  async fetchAll(searchFilterPagination) {
    try {
      const request = ++currentRequest;
      console.log(`[${request}] START TENANT `, searchFilterPagination.search);
      const res = await Vue.$jsonApi.findAll("tenants", searchFilterPagination);
      if (request !== currentRequest) {
        console.log(`[${request}] TENANT DISCARDED`);
        return null;
      }
      console.log(`[${request}] END TENANT `, searchFilterPagination.search);
      return res;
    } catch (error) {
      console.log("fetchAll error: ", error);
      return { error: error };
    }
  },
  async createOrUpdate(payload) {
    try {
      if (payload.id == "" || payload.id == null) {
        return await Vue.$jsonApi.create("tenant", payload);
      } else {
        return await Vue.$jsonApi.update("tenant", payload);
      }
    } catch (error) {
      console.log("createOrUpdate error: ", error);
      return { error: error };
    }
  },
  async delete(id) {
    if (id == null) {
      return null;
    }
    try {
      const data = await Vue.$jsonApi.destroy("tenant", id);
      return data;
    } catch (error) {
      console.log("delete error: ", error);
      return { error: error };
    }
  }
};

export { TenantService };
